<template>
  <div>
    <access-tab-list
      :accesses="parentAccesses"
      :parent-allotments="parentAllotments"
      :account="account"
      :channel="channel"
      @afterUpdateAccess="$emit('afterUpdateAccess')"
      @afterCreatedAccess="$emit('afterCreatedAccess')"
      @afterDeleteAccess="$emit('afterDeleteAccess')">
    </access-tab-list>
  </div>
</template>

<script>
export default {
  name: 'CompanyAccesses',
  components: {
    AccessTabList: () => import('@/components/access/AccessTabList')
  },
  props: {
    parentAccesses: {
      type: Array
    },
    parentAllotments: {
      type: Array
    },
    channel: {
      type: Object
    }
  },
  computed: {
    account () {
      return this.$route.params.id
    }
  }
}
</script>
